export function HowItWorksPage({ copy, onGetStarted, onOpenPricing, onOpenSecurity }) {
  return (
    <article className="resource-page" lang={copy.locale}>
      <header className="resource-page-intro how-page-intro">
        <div className="how-page-intro-grid">
          <div className="how-page-intro-main">
            <div className="how-page-intro-copy">
              <p className="resource-page-kicker">{copy.kicker}</p>
              <h1 id="how-page-title" className="resource-page-title">
                {copy.title}
              </h1>
              <p className="resource-page-lead">{copy.lead}</p>
            </div>

            <section className="how-intro-steps" aria-labelledby="how-steps">
              <div className="resource-section-head">
                <h2 id="how-steps">{copy.stepsHeading}</h2>
                <p>{copy.stepsLead}</p>
              </div>
              <div className="resource-step-grid how-intro-step-grid">
                {copy.steps.map((item) => (
                  <article key={item.step} className="resource-step-card">
                    <span className="resource-step-pill">{item.step}</span>
                    <h3>{item.title}</h3>
                    <p>{item.body}</p>
                  </article>
                ))}
              </div>
            </section>
          </div>

          <aside className="how-overview-panel" aria-label={copy.overviewAria}>
            <p className="how-overview-kicker">{copy.overviewKicker}</p>
            <h2 className="how-overview-title">{copy.overviewTitle}</h2>
            <div className="how-overview-list">
              {copy.overviewGroups.map((item) => (
                <article key={item.title} className="how-overview-item">
                  <div className="how-overview-step-pair" aria-hidden>
                    {item.steps.map((step) => (
                      <span key={step} className="how-overview-step">
                        {step}
                      </span>
                    ))}
                  </div>
                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.body}</p>
                  </div>
                </article>
              ))}
            </div>
          </aside>
        </div>
      </header>

      <section className="resource-section resource-callout-section" aria-labelledby="how-notes">
        <div className="resource-section-head">
          <h2 id="how-notes">{copy.notesHeading}</h2>
        </div>
        <ul className="resource-check-list">
          {copy.notes.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="resource-cta" aria-labelledby="how-cta">
        <div className="resource-cta-copy">
          <p className="resource-page-kicker">{copy.ctaKicker}</p>
          <h2 id="how-cta">{copy.ctaTitle}</h2>
          <p>{copy.ctaBody}</p>
        </div>
        <div className="resource-cta-actions">
          {typeof onGetStarted === "function" ? (
            <button type="button" onClick={onGetStarted}>
              {copy.primaryCta}
            </button>
          ) : null}
          {typeof onOpenPricing === "function" ? (
            <button type="button" className="secondary" onClick={onOpenPricing}>
              {copy.pricingCta}
            </button>
          ) : null}
          {typeof onOpenSecurity === "function" ? (
            <button type="button" className="secondary" onClick={onOpenSecurity}>
              {copy.securityCta}
            </button>
          ) : null}
        </div>
      </section>
    </article>
  );
}
